<div fxLayout="row" class="p-24" (swipedown)="closeBottomSheet('')">
    <p *ngIf="data?.title" class="title"> {{data.title | translate }}</p>
    <div [ngClass]="{'mt-24': data?.title}" fxLayout="column">
        <button *ngIf="data?.selectedButton !== 'ACCEPTED' && data?.type !== 'REJECT_ALL_EVENTS'" class="w-100-p p-12 mb-16 btn btn--accept"
            (click)="closeBottomSheet(actionTypes.ACCEPT)">
            {{ data?.primaryButtonTitle | translate }} {{ data?.primaryButtonSubtitle }}
        </button>
        <button *ngIf="data?.selectedButton !== 'REJECTED' && data?.type !== 'ACCEPT_ALL_EVENTS'" class="w-100-p p-12 mb-16 btn btn--reject"
            (click)="closeBottomSheet(actionTypes.REJECT)">
            {{ data?.secondaryButtonTitle | translate }} {{ data?.secondaryButtonSubtitle }}
        </button>
        <button *ngIf="data?.selectedButton === 'ACCEPTED' || data?.selectedButton === 'REJECTED'" class="w-100-p p-12 mb-16 btn btn--open"
            (click)="closeBottomSheet(actionTypes.OPEN)">
            {{ data?.openButtonTitle | translate }} {{ data?.openButtonSubtitle }}
        </button>
    </div>
</div>